import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=15a24d2f&scoped=true"
import script from "./script?vue&type=script&lang=js&external"
export * from "./script?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a24d2f",
  null
  
)

export default component.exports